module.exports = __webpack_public_path__ + "static/media/sand-towers.c52a8d36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landscape/sand-towers.jpg
// module id = 117
// module chunks = 0